import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { RepairJobFilters, RepairJobFormData } from "../Types";
import { createRepairJob, deleteRepairJob, getRepairJobs, updateRepairJob, updateRepairJobStatus } from "../Api";

export const useRepairJobQuery = (filters: RepairJobFilters) => {
  return useQuery({
    queryKey: ["repair-jobs", filters],
    queryFn: () => getRepairJobs(filters),
  });
};

export const useRepairJobCreateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: RepairJobFormData) => createRepairJob(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["repair-jobs"] });
    },
  });
};

export const useRepairJobUpdateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: RepairJobFormData & { id: string }) =>
      updateRepairJob(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["repair-jobs"] });
    },
  });
};

export const useRepairJobStatusUpdateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { id: string; status: string; status_note?: string }) =>
      updateRepairJobStatus(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["repair-jobs"] });
    },
  });
};

export const useRepairJobDeleteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteRepairJob(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["repair-jobs"] });
    },
  });
};

